import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icons from "../icons";

const Modal = ({
  backgroundDrop,
  isOpen = false,
  onCloseModal,
  children,
  className = "",
  idName = "",
  isCloseButton = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const backDropClick = (e) => {
    if (backgroundDrop) {
      setIsModalOpen(false);
      onCloseModal();
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    onCloseModal();
  };
  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      {isModalOpen && (
        <div className="modalWrapper" onClick={backDropClick}>
          <div
            className={classNames("modalInner", className)}
            id={idName}
            onClick={(e) => e.stopPropagation()}
          >
            {isCloseButton && (
              <button className="closeModal" onClick={closeModal}>
                {Icons.closeIcon}
              </button>
            )}
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
